type ShowNotification = {
	type: NotificationActionType.SHOW_NOTIFICATION;
	payload: Notification;
};

type HideNotification = {
	type: NotificationActionType.HIDE_NOTIFICATION;
	payload: string;
};

export enum NotificationActionType {
	SHOW_NOTIFICATION = '@komigen/mobile-frontend/notifications/SHOW_QUEUED_NOTIFICATION',
	HIDE_NOTIFICATION = '@komigen/mobile-frontend/notifications/HIDE_QUEUED_NOTIFICATION'
}

export type NotificationAction = ShowNotification | HideNotification;

export type Notification = {
	id: string;
	shouldOpen: boolean;
	icon?: string;
	message?: string;
	messageKey?: string;
	title?: string;
	titleKey?: string;
	color?: string;
	centerAligned?: boolean;
	customMargin?: string;
	openInSidebar?: boolean;
	autoHide?: boolean;
	autoHideDuration?: number;
	buttonLink?: string;
	buttonText?: string;
	buttonTextKey?: string;
	buttonInline?: boolean;
	buttonLinkInternal?: string;
	buttonBottom?: boolean;
	linkCB?: () => void;
	onCloseClickCallback?: () => void;
	onBluebarClick?: () => void;
	buttonCB?: () => void;
};
